import { render, staticRenderFns } from "./BatchUpload.vue?vue&type=template&id=45973f28&scoped=true"
import script from "./BatchUpload.vue?vue&type=script&lang=js"
export * from "./BatchUpload.vue?vue&type=script&lang=js"
import style0 from "./BatchUpload.vue?vue&type=style&index=0&id=45973f28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45973f28",
  null
  
)

export default component.exports